<template>
  <div id="statement"
    :style="{
            background: `linear-gradient(180deg, ${colors[colors.theme].to}   0%,  ${colors[colors.theme].from} 100%)`,
            color: colors.theme == 'dark' ? `#fff` : `#000`
        }">
    <div
      id="statement_header"
      :style="{
            color: colors.theme == 'dark' ? `#fff` : `#000`,
            border: colors.theme == 'dark' ? `1px solid #fff` : `1px solid #000`
        }"
    >
      <h1 :style="{color: colors.theme == 'dark' ? `#fff` : `#000`}">{{ $t("views.statementGame.titles[0]") }}</h1>
    </div>

    <div id="statement_content" :style="{color: colors.theme == 'dark' ? `#fff` : `#000`}">
      <div class="content">
        <!-- <h1 :style="{color: colors.theme == 'dark' ? `#fff` : `#000`">{{ $t("views.statementGame.titles[0]") }}</h1> -->
        <p>{{ $t("views.statementGame.paragraphs[0]") }}</p>
        <p>{{ $t("views.statementGame.paragraphs[1]") }}</p>
        <p>{{ $t("views.statementGame.paragraphs[2]") }}</p>
        <p>{{ $t("views.statementGame.paragraphs[3]") }}</p>
        <p>{{ $t("views.statementGame.paragraphs[4]") }}</p>

        <div
          class="show_more"
          :style="{color: `${colors.secondary}`}"
          v-show="show_more"
          @click="seeMore"
        >{{ $t("views.statementGame.seeMoreLink") }}</div>
        <div class="more" v-show="!show_more">
          <h2 :style="{color: colors.theme == 'dark' ? `#fff` : `#000`}">{{ $t("views.statementGame.titles[1]") }}</h2>
          <p>{{ $t("views.statementGame.paragraphs[5]") }}</p>

          <ol>
            <li class="clause">{{ $t("views.statementGame.titles[2]") }}</li>
            <ol class="ordened_number">
              <li>
                <span class="spacement">1.1</span>{{ $t("views.statementGame.paragraphs[6]") }}
              </li>
              <ul class="bullet">
                <li>{{ $t("views.statementGame.paragraphs[7]") }}</li>
                <li>{{ $t("views.statementGame.paragraphs[8]") }}</li>
              </ul>
              <li>
                <span class="spacement">1.2</span> {{ $t("views.statementGame.paragraphs[9]") }}
                <a
                  :style="{color: `${colors.secondary}`}"
                  href="http://www.facebook.com/huddleBR/inbox"
                  target="_blank"
                >Facebook</a> {{ $t("views.statementGame.paragraphs[10]") }}
              </li>
            </ol>
            <li class="clause">{{ $t("views.statementGame.titles[2]") }}</li>
            <ol>
              <li>
                <span class="spacement">2.1</span> {{ $t("views.statementGame.paragraphs[11]") }}
              </li>
              <li>
                <span class="spacement">2.2</span> {{ $t("views.statementGame.paragraphs[12]") }}
                <a
                :style="{color: `${colors.secondary}`}"
                  href="https://repense-game.huddlebrasil.com/rules"
                  target="_blank"
                >{{ $t("views.statementGame.paragraphs[13]") }}</a>.
              </li>
              <li>
                <span class="spacement">2.3</span> {{ $t("views.statementGame.paragraphs[14]") }}
              </li>
              <li>
                <span class="spacement">2.4</span> {{ $t("views.statementGame.paragraphs[15]") }}
              </li>
              <li>
                <span class="spacement">2.5</span> {{ $t("views.statementGame.paragraphs[16]") }}
              </li>
              <li>
                <span class="spacement">2.6</span> {{ $t("views.statementGame.paragraphs[17]") }}
              </li>
              <li>
                <span class="spacement">2.7</span> {{ $t("views.statementGame.paragraphs[18]") }}
              </li>
            </ol>
            <li class="clause">{{ $t("views.statementGame.titles[3]") }}</li>
            <ol>
              <li>
                <span class="spacement">3.1</span>{{ $t("views.statementGame.paragraphs[19]") }}
              </li>
            </ol>
            <li class="clause">{{ $t("views.statementGame.titles[4]") }}</li>
            <ol>
              <li>
                <span class="spacement">4.1</span>{{ $t("views.statementGame.paragraphs[20]") }}
              </li>
              <li>
                <span class="spacement">4.2</span>{{ $t("views.statementGame.paragraphs[21]") }}
              </li>
              <li>
                <span class="spacement">4.3</span>{{ $t("views.statementGame.paragraphs[22]") }}
              </li>
              <li>
                <span class="spacement">4.4</span>{{ $t("views.statementGame.paragraphs[23]") }}
              </li>
            </ol>
            <li class="clause">{{ $t("views.statementGame.titles[5]") }}</li>
            <ol>
              <li>
                <span class="spacement">5.1</span>{{ $t("views.statementGame.paragraphs[24]") }}
              </li>
              <li>
                <span class="spacement">5.2</span>{{ $t("views.statementGame.paragraphs[25]") }}
              </li>
            </ol>

            <li class="clause">{{ $t("views.statementGame.titles[6]") }}</li>
            <ol>
              <li>
                <span class="spacement">6.1</span>{{ $t("views.statementGame.paragraphs[26]") }}
              </li>

              <ol>
                <li
                  class="roman"
                >{{ $t("views.statementGame.paragraphs[27]") }}</li>
                <li
                  class="roman"
                >{{ $t("views.statementGame.paragraphs[28]") }}</li>
                <li
                  class="roman"
                >{{ $t("views.statementGame.paragraphs[29]") }}</li>
                <ul>
                  <li
                    class="alpha"
                  >{{ $t("views.statementGame.paragraphs[30]") }}</li>
                </ul>
                <li
                  class="roman"
                >{{ $t("views.statementGame.paragraphs[31]") }}</li>
                <li
                  class="roman"
                >{{ $t("views.statementGame.paragraphs[32]") }}</li>
              </ol>
              <li>
                <span class="spacement">6.2</span>{{ $t("views.statementGame.paragraphs[33]") }}
              </li>
              <li>
                <span class="spacement">6.3</span>{{ $t("views.statementGame.paragraphs[34]") }}
              </li>
              <li>
                <span class="spacement">6.4</span>{{ $t("views.statementGame.paragraphs[35]") }}
              </li>
              <li>
                <span class="spacement">6.5</span>{{ $t("views.statementGame.paragraphs[36]") }}
              </li>
              <li>
                <span class="spacement">6.6</span>{{ $t("views.statementGame.paragraphs[37]") }}
              </li>
              <li>
                <span class="spacement">6.7</span>{{ $t("views.statementGame.paragraphs[38]") }}
              </li>
              <li>
                <span class="spacement">6.8</span>{{ $t("views.statementGame.paragraphs[39]") }}
              </li>
            </ol>
            <li class="clause">{{ $t("views.statementGame.titles[7]") }}</li>
            <ol>
              <li>
                <span class="spacement">7.1</span>{{ $t("views.statementGame.paragraphs[40]") }}
              </li>
              <ul>
                <li class="alpha">{{ $t("views.statementGame.paragraphs[41]") }}</li>
                <li
                  class="alpha"
                >{{ $t("views.statementGame.paragraphs[42]") }}</li>
                <li class="alpha">{{ $t("views.statementGame.paragraphs[43]") }}</li>
                <li
                  class="alpha" 
                >{{ $t("views.statementGame.paragraphs[44]") }}</li>
                <li class="alpha">{{ $t("views.statementGame.paragraphs[45]") }}</li>
              </ul>
              <li>
                <span class="spacement">7.2</span>{{ $t("views.statementGame.paragraphs[46]") }}
              </li>
              <li>
                <span class="spacement">7.3</span>{{ $t("views.statementGame.paragraphs[47]") }}
              </li>
              <ol>
                <li>
                  <span class="spacement">7.3.1</span>{{ $t("views.statementGame.paragraphs[48]") }}
                </li>
              </ol>
            </ol>
            <li class="clause">{{ $t("views.statementGame.titles[8]") }}</li>
            <ol>
              <li>
                <span class="spacement">8.1</span>{{ $t("views.statementGame.paragraphs[49]") }}
              </li>
              <li>
                <span class="spacement">8.2</span>{{ $t("views.statementGame.paragraphs[50]") }}
              </li>
            </ol>
            <li class="clause">{{ $t("views.statementGame.titles[9]") }}</li>
            <ol>
              <li>
                <span class="spacement">9.1</span>{{ $t("views.statementGame.paragraphs[51]") }}
              </li>
            </ol>
            <li class="clause">{{ $t("views.statementGame.titles[10]") }}</li>
            <ol>
              <li>
                <span class="spacement">10.1</span>{{ $t("views.statementGame.paragraphs[52]") }}
              </li>
            </ol>
          </ol>
        </div>
      </div>
    </div>

    <div id="statement_acceptance">
      <div class="acceptance_checkbox" :style="{
            color: colors.theme == 'dark' ? `#fff` : `#000`
        }">
        <input type="checkbox" name="acceptance" id="acceptance" v-model="checked" @click="scroll" />
        <label for="acceptance" :style="{color: colors.theme == 'dark' ? `#fff` : `#000`}">
          <strong>
            {{ $t("views.statementGame.paragraphs[53]") }}
            </strong> 
            {{ $t("views.statementGame.paragraphs[54]") }}
        </label>
      </div>
      <div
        class="acceptance_button"
        :style="{
          background: checked ? `${colors.secondary}` : '#f4f4f4',
          color: checked ? '#fff' : '#bcc7ce'
        }"
        :class="{disabled: !checked}"
        @click="next"
      >
        <span>{{ $t("views.statementGame.textButton") }}</span>
        <div class="arrow-right"
          :style="{
            borderLeft: '6px solid #fff'
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatementOfUse",

  data: () => ({
    checked: false,
    show_more: true,
    colors: {}
  }),

  created() {
    this.colors = JSON.parse(localStorage.getItem("colors"));
  },

  methods: {
    scroll() {
      // window.scrollTo(0,5000)
    },
    next() {
      if (this.checked) {
        // this.checked = !this.checked
        this.$router.push("/rules");
      }
    },

    seeMore() {
      this.show_more = !this.show_more;
    }
  }
};
</script>


<style lang="scss">
#statement {
  display: flex;
  flex-direction:column;
  // justify-content: space-between;
  gap: 1rem;
  width: 100%;
  height: 100%;

  #statement_header {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1rem auto 0 auto;
    padding: .5rem;
    border-radius: 400px;
    font-weight: 600;

    h1{
      font-size: 1em;
    }
  }

  #statement_content {
    display: flex;
    flex-grow: 1;
    padding: 0 2rem;
    // margin: 25px 0;
    //height: 65vh;
    overflow-y: scroll;

    .content {
      h1,
      h2 {
        text-transform: uppercase;
        font-weight: 700;
        margin: 32px 0 15px 0;
      }

      p,
      ul,
      ol,
      li {
        font-size: 15px;
        line-height: 24px;
      }
      ol {
        margin: 15px 0 0 15px;
      }
      li {
        padding: 10px 0;
      }
      .clause {
        list-style-type: decimal;
        padding: 20px 15px 0 15px;

        &:before {
          padding-left: 32px;
        }
      }

      .bullet {
        list-style-type: disc;
        margin: 0 32px;
      }
      .roman {
        list-style-type: upper-roman;
        margin: 0 32px;
      }
      .alpha {
        list-style-type: lower-alpha;
        margin: 0 0 0 64px;
      }
      .spacement {
        padding-right: 15px;
      }
    }

    p {
      padding: 5% 0 0 0;
      font-size: 11pt;
      line-height: 20px;
    }

    .show_more {
      padding: 25px 0;
      font-weight: 700;
      // color: #83037d;

      &:hover {
        cursor: pointer;
      }
    }
  }
  #statement_acceptance {
    margin: 0 auto;
    padding-bottom: 1rem;
    .acceptance_checkbox {
      color: rgb(204, 204, 204);
      display: flex;
      justify-content: center;
      align-items: center;
      //margin: 40px auto;
      margin: 1em auto 1em;
      /* background: rgb(0, 0, 0); */
      // background-color: rgba($color: #02f0e4, $alpha: 0.3);

      input{
        width: 23px;
        height: 23px;
      }

      label {
        // color: #83037d;
        // font-size: 15px;
        margin-left: 10px;

        strong {
          font-weight: 700;
        }
      }
    }
    .acceptance_button {
      display: flex;
      align-items: center;
      text-align: center;
      // color: #000;
      font-weight: 700;
      text-decoration: none;
      max-width: 300px;
      margin: 0 auto;
      border-radius: 300px;
      padding: 23px 0;

      span {
        font-size: 15px;
        letter-spacing: 3px;
        text-transform: uppercase;
        width: 90%;
        position: relative;
        left: 15px;        
      }

      .arrow-right {
        width: 0;
        height: 0;
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        // border-left: 6px solid #000;
        width: 10%;
      }
    }

    .disabled {
      &:hover {
        cursor: not-allowed;
      }
      color: #bcc7ce;
      background-color: #f4f4f4;
    }
  }
}
@media screen and (max-width: 400px) {
  #statement_header {
    font-size: 19px;
  }
  #statement_content {
    overflow-y: scroll;
  }
  #statement_acceptance {
    .acceptance_checkbox {
      span {
        font-size: 15px;
      }
    }
  }
}
@media screen and (min-width: 720px) {
  #statement #statement_header{
    margin-top: 2rem;
  }
  #statement #statement_content{
    padding: 0 9rem;
    overflow-x: auto;
    //height: 40vh !important;
  }
  #statement #statement_acceptance{
    padding-bottom: 2rem;
  }
}
</style>